export function compareProperty(a?: string, b?: string): number {
  return a || b ? (!a ? -1 : !b ? 1 : a.localeCompare(b)) : 0;
}

export function compareSortAndName(a: { sort?: string; name?: string }, b: { sort?: string; name?: string }): number {
  return compareProperty(a.sort, b.sort) || compareProperty(a.name, b.name);
}
